import { useEffect, useState } from "react";
import getClientSideSplitTreatments from "./getClientSideSplitTreatments";
const LOADING_STATE = Object.freeze({
    isLoading: true,
    treatments: {},
});
const useClientSideSplitTreatments = (treatmentNames, splitKey, options = {}) => {
    const [treatments, setTreatments] = useState(LOADING_STATE);
    useEffect(() => {
        setTreatments(LOADING_STATE);
        getClientSideSplitTreatments(treatmentNames, splitKey, {
            apiPathString: options.apiPathString,
            attributes: options.attributes,
        }).then((treatments) => {
            setTreatments({ isLoading: false, treatments });
        });
    }, [JSON.stringify(treatmentNames)]);
    return treatments;
};
export default useClientSideSplitTreatments;
